export const ROUTE_PATHS = {
  HOME: '/',
  MENTIONS_LEGALES: '/mentions-legales',
}

export interface FormationModule {
  id: string
  title: string
  description: string
  duration: string
  level: string
  icon: string
}

// ── Textes par défaut ─────────────────────────────────────────────────────────
export const DEFAULT_TEXTS: Record<string, string> = {
  'hero.badge':       'Formateur certifié • Ambassadeur international',
  'hero.name':        'Sidi Bensoula',
  'hero.tagline':     'Coiffeur • Barber • Formateur',
  'hero.subtitle':    'Plus de 20 ans d\'expertise au service de la coiffure masculine d\'exception.',
  'hero.cta1':        'Découvrir les formations',
  'hero.cta2':        'Me contacter',
  'hero.pill1.title': 'Ambassadeur Wahl',
  'hero.pill1.desc':  'Éducateur et démonstrateur officiel Wahl Professional',
  'hero.pill2.title': 'American Crew',
  'hero.pill2.desc':  'Formateur et ambassadeur American Crew France',
  'hero.pill3.title': 'Académie SB',
  'hero.pill3.desc':  'Fondateur de l\'Académie Sidi Bensoula',

  'about.tag':        'À propos',
  'about.title':      'Sidi Bensoula',
  'about.subtitle':   'Un parcours construit sur la passion, l\'exigence et la transmission.',
  'about.bio':        'Je suis coiffeur styliste, barber et formateur, avec plus de 25 ans d\'expérience dans la coiffure masculine. Au fil des années, j\'ai construit mon expertise autour d\'une exigence simple : la précision du geste, la maîtrise des techniques et le sens du détail.\n\nJe travaille aussi bien aux ciseaux qu\'à la tondeuse, deux outils que je maîtrise avec précision, au service de coupes structurées, propres et modernes.\n\nMon parcours m\'a amené à évoluer à l\'international en tant qu\'éducateur, notamment avec American Crew France et Wahl Professional, où je transmets mon savoir-faire à travers des formations, des démonstrations et des masterclass.\n\nJ\'ai également fondé l\'Académie Sidi Bensoula, un espace dédié à la montée en compétence des professionnels, avec des formations exigeantes, concrètes et orientées terrain.',
  'about.stat1.number': '20+',
  'about.stat1.label':  'Ans d\'expérience',
  'about.stat2.number': '500+',
  'about.stat2.label':  'Professionnels formés',
  'about.stat3.number': '3',
  'about.stat3.label':  'Pays d\'intervention',
  'about.val1': 'Précision',
  'about.val2': 'Excellence',
  'about.val3': 'Transmission',
  'about.val4': 'Créativité',
  'about.val5': 'Modernité',

  'formation.tag':      'Formations',
  'formation.title':    'Mes Programmes',
  'formation.subtitle': 'Des formations professionnelles pour développer votre expertise et élever votre pratique.',
  'formation.cta':      'Demander un programme',

  'collabs.tag':      'Collaborations',
  'collabs.title':    'Mes Partenaires',
  'collabs.subtitle': 'Des collaborations au service de l\'excellence en coiffure masculine.',
  'collabs.wahl.name': 'Wahl Professional',
  'collabs.wahl.role': 'Ambassadeur & Éducateur',
  'collabs.wahl.desc': 'Formateur et démonstrateur officiel pour Wahl Professional, référence mondiale des outils de coiffure.',
  'collabs.ac.name':   'American Crew',
  'collabs.ac.role':   'Formateur & Ambassadeur France',
  'collabs.ac.desc':   'Transmission des techniques et des valeurs American Crew auprès des professionnels français.',
  'collabs.events.name': 'Événements & Shows',
  'collabs.events.role': 'Démonstrations live',
  'collabs.events.desc': 'Présence sur les grandes scènes de la coiffure masculine en France et à l\'international.',

  'gallery.tag':   'Galerie',
  'gallery.title': 'L\'Univers en Images',

  'contact.tag':      'Contact',
  'contact.title':    'Travaillons ensemble',
  'contact.subtitle': 'Une question sur mes formations ? N\'hésitez pas à me contacter.',
  'contact.desc':     'Retrouvez-moi sur les réseaux sociaux ou contactez-moi directement par email ou WhatsApp.',
  'contact.instagram': '@sidi_bensoula',
  'contact.facebook':  'Sidi Bensoula',
  'contact.email':     'sidi.bensoula@gmail.com',
  'contact.cta':       'Me contacter sur WhatsApp',

  'footer.tagline':   'Formateur en coiffure masculine d\'excellence',
  'footer.copyright': '© 2026 Sidi Bensoula. Tous droits réservés.',
}

// ── Modules par défaut ────────────────────────────────────────────────────────
export const DEFAULT_MODULES: FormationModule[] = [
  {
    id: 'mod1',
    title: 'Masterclass Coupe Homme',
    description: 'Développez une maîtrise avancée du travail au ciseau et comprenez les fondamentaux essentiels graduation, élévation, dégradé pour signer des coupes précises, structurées et haut de gamme.',
    duration: '1 jour',
    level: 'Intermédiaire / Avancé',
    icon: 'scissors',
  },
  {
    id: 'mod2',
    title: 'Barber Intensif',
    description: 'Maîtrisez les techniques de dégradé, contours et finitions au rasoir pour un résultat impeccable et moderne.',
    duration: '2 jours',
    level: 'Tous niveaux',
    icon: 'star',
  },
  {
    id: 'mod3',
    title: 'Modern Barbering',
    description: 'Maîtrisez les techniques incontournables du barbering moderne : taper fade, dégradé, burst fade et modern mullet. Une formation intensive pour gagner en précision, en rapidité et en qualité d\'exécution, adaptée aux exigences des clients d\'aujourd\'hui.',
    duration: '3 jours',
    level: 'Avancé',
    icon: 'award',
  },
]

// ── URLs images par défaut (Unsplash fallback) ────────────────────────────────
export const DEFAULT_IMAGES: Record<string, string> = {
  'hero.bg':        'https://images.unsplash.com/photo-1503951914875-452162b0f3f1?w=1920&q=80',
  'about.photo':    'https://images.unsplash.com/photo-1622287162716-f311baa1a2b8?w=800&q=80',
  'gallery.1':      'https://images.unsplash.com/photo-1593702288056-7cc9c7d87f36?w=600&q=80',
  'gallery.2':      'https://images.unsplash.com/photo-1622286342621-4bd786c2447c?w=600&q=80',
  'gallery.3':      'https://images.unsplash.com/photo-1503951914875-452162b0f3f1?w=600&q=80',
  'gallery.4':      'https://images.unsplash.com/photo-1621605815971-fbc98d665033?w=600&q=80',
  'gallery.5':      'https://images.unsplash.com/photo-1599351431202-1e0f0137899a?w=600&q=80',
  'gallery.6':      'https://images.unsplash.com/photo-1605497788044-5a32c7078486?w=600&q=80',
  'formation.mod1': 'https://images.unsplash.com/photo-1621605815971-fbc98d665033?w=600&q=80',
  'formation.mod2': 'https://images.unsplash.com/photo-1599351431202-1e0f0137899a?w=600&q=80',
  'formation.mod3': 'https://images.unsplash.com/photo-1605497788044-5a32c7078486?w=600&q=80',
}

// Clé spéciale pour stocker les modules dans Supabase
export const MODULES_CONTENT_KEY = '__modules__'
